export var valuesPlaylistAssignementReason = ["Manual", "Rule"];
/*

*/ 
//# sourceMappingURL=PlaylistAssignementReason.js.map